

customElements.get("product-form") || customElements.define("product-form", class extends HTMLElement {
  constructor() {
    super(), this.originalButtonText = "", this.persistentTextActive = !1
  }
connectedCallback() {
  setTimeout(() => {
    if (this.form = this.querySelector("form"), !this.form) return;

    // 🔥 Initialiser les cartes d'upsell UNIQUEMENT dans CE product-form


    const t = this.variantIdInput;
    if (t && (t.disabled = !1),
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
      this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer"),
      this.submitButton = this.querySelector('[type="submit"]'),
      this.submitButton
    ) {

      if (this.submitButtonText = this.submitButton.querySelector(".button-text"),
        this.submitButtonText && (
          this.originalButtonText = this.submitButtonText.textContent,
          this.submitButton.dataset.originalText = this.originalButtonText
        ),
        "true" === this.submitButton.dataset.textOverride && this.submitButtonText
      );

      else if (this.submitButton.classList.contains("has-persistent-text") && this.submitButtonText) {
        this.persistentTextActive = !0;
        const t = this.submitButton.dataset.persistentText;
        if (t) {
          this.submitButtonText.textContent = t,
          localStorage.setItem("addToCartButtonText", t)
        } else {
          const t = localStorage.getItem("addToCartButtonText");
          t && (
            this.submitButtonText.textContent = t,
            this.submitButton.dataset.persistentText = t
          )
        }
      }

      (this.persistentTextActive || "true" === this.submitButton.dataset.textOverride)
      && this.submitButtonText
      && this.setupButtonTextObserver(),

      document.querySelector("cart-drawer")
      && this.submitButton.setAttribute("aria-haspopup", "dialog"),

      this.hideErrors = "true" === this.dataset.hideErrors,

      document.addEventListener("variant:change", this.handleVariantChange.bind(this))
    }
  }, 100);
}


  setupButtonTextObserver() {
    if (!this.submitButtonText) return;
    const t = { characterData: !0, childList: !0, subtree: !0 };
    if (this.persistentTextActive) {
      const e = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
      if (!e) return;
      this.buttonTextObserver = new MutationObserver((t => {
        this.submitButtonText.textContent !== e && (this.submitButtonText.textContent = e)
      })),
        this.buttonTextObserver.observe(this.submitButtonText, t)
    }
  }

  handleVariantChange(t) {
    this.submitButtonText && setTimeout(() => {
      if (this.persistentTextActive) {
        const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
        t && (this.submitButtonText.textContent = t)
      }
    }, 50)
  }

  async onSubmitHandler(t) {
    t.preventDefault();
    if ("true" === this.submitButton.getAttribute("aria-disabled")) return;

    this.handleErrorMessage(),
      this.submitButton.setAttribute("aria-disabled", !0),
      this.submitButton.classList.add("loading"),
      this.querySelector(".loading__spinner").classList.remove("hidden");

    /** FETCH CONFIG **/
    const e = fetchConfig("javascript");
    e.headers["X-Requested-With"] = "XMLHttpRequest";
    delete e.headers["Content-Type"];

    /** FORM DATA */
    const s = new FormData(this.form);

        /* ----------------------------------------------------------
       🔥 UPSSELL MYMOODZ : récupération du select upsell
       ---------------------------------------------------------- */
    let selectedUpsellVariant = null;
    let selectedUpsellLabel   = null;

    try {
      // Variante actuellement sélectionnée dans le form
      const activeVariantInput = this.form.querySelector('[name="id"]');
      const activeVariantId = activeVariantInput ? activeVariantInput.value : null;

      if (activeVariantId) {
        // On cherche le select d'upsell lié à cette variante
        const upsellSelect = document.querySelector(
          `[data-upsell-select="true"][data-upsell-variant-id="${activeVariantId}"]`
        );

        if (upsellSelect && upsellSelect.value !== "") {
          selectedUpsellVariant = upsellSelect.value;
          selectedUpsellLabel   = upsellSelect.options[upsellSelect.selectedIndex].text.trim();
        }
      }

      console.log("[UPSSELL PF] selectedUpsellVariant =", selectedUpsellVariant);
      console.log("[UPSSELL PF] selectedUpsellLabel   =", selectedUpsellLabel);
      console.log("[UPSSELL PF] parentVariantId       =", s.get("id"));
    } catch (err) {
      console.error("Erreur UPSSELL MyMoodz :", err);
    }
    /* ---------------------------------------------------------- */





    this.cart && (
      s.append("sections", this.cart.getSectionsToRender().map(t => t.id)),
      s.append("sections_url", window.location.pathname),
      this.cart.setActiveElement(document.activeElement)
    );

    e.body = s;

    fetch(`${routes.cart_add_url}`, e)
      .then(t => t.json())
      .then(async t => {

        /* ERREUR SHOPIFY */
        if (t.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: s.get("id"),
            errors: t.errors || t.description,
            message: t.message
          }),
            this.handleErrorMessage(t.description);

          const e = this.submitButton.querySelector(".sold-out-message");
          if (!e) return;

          this.submitButton.setAttribute("aria-disabled", !0),
            this.submitButtonText.classList.add("hidden"),
            e.classList.remove("hidden"),
            this.error = !0;

          return;
        }

                // 👉 On part de l'état renvoyé après ajout du parent
        let finalState = t;

        /* ----------------------------------------------------------
           🔥 UPSSELL : second ajout au panier via routes.cart_add_url
           ---------------------------------------------------------- */
        if (selectedUpsellVariant && this.cart) {
          try {
const upsellForm = new FormData();
upsellForm.append("id", selectedUpsellVariant);
upsellForm.append("quantity", "1");

// on lie l'enfant au parent via une property privée
upsellForm.append(
  "properties[_upsell_parent_variant_id]",
  s.get("id") // variante parent ajoutée juste avant
);

// 🔥 propriété visible dans le panier + checkout
upsellForm.append("properties[Cadeau]", "Cadeau offert");


            const sectionsToRender = this.cart.getSectionsToRender().map(section => section.id);
            upsellForm.append("sections", sectionsToRender);
            upsellForm.append("sections_url", window.location.pathname);

            const upsellConfig = fetchConfig("javascript");
            upsellConfig.headers["X-Requested-With"] = "XMLHttpRequest";
            delete upsellConfig.headers["Content-Type"];
            upsellConfig.body = upsellForm;

            const upsellResp  = await fetch(routes.cart_add_url, upsellConfig);
            const upsellState = await upsellResp.json();

            console.log("[UPSSELL PF] upsellState =", upsellState);

            if (!upsellState.status) {
              // ✅ on remplace l'état par celui qui inclut l'upsell
              finalState = upsellState;
            } else {
              console.error("[UPSSELL PF] Erreur Shopify upsell :", upsellState);
            }
          } catch (err) {
            console.error("[UPSSELL PF] Erreur ajout upsell :", err);
          }
        }
        /* ---------------------------------------------------------- */






        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        const e = CartPerformance.createStartingMarker("add:wait-for-subscribers");
        this.error || publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: s.get("id"),
          cartData: finalState
        })
          .then(() => {
            CartPerformance.measureFromMarker("add:wait-for-subscribers", e)
          }),

          this.error = !1;

        const i = this.closest("quick-add-modal");
        i ?
          (document.body.addEventListener("modalClosed", () => {
            setTimeout(() => {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(finalState)
              })
            })
          }, { once: !0 }),
            i.hide(!0))
          :
          CartPerformance.measure("add:paint-updated-sections", () => {
            this.cart.renderContents(finalState)
          })
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.submitButton.classList.remove("loading"),
          this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"),
          this.error || this.submitButton.removeAttribute("aria-disabled"),
          this.querySelector(".loading__spinner").classList.add("hidden"),

          (!this.error && this.persistentTextActive) && (() => {
            const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
            t && this.submitButtonText && (this.submitButtonText.textContent = t)
          })(),

          CartPerformance.measureFromEvent("add:user-action", t)
      })
  }

  handleErrorMessage(t = !1) {
    if (this.hideErrors) return;
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
    this.errorMessageWrapper && (
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message"),
      this.errorMessageWrapper.toggleAttribute("hidden", !t),
      t && (this.errorMessage.textContent = t)
    )
  }

  toggleSubmitButton(t = !0, e) {
    if (t) this.submitButton.setAttribute("disabled", "disabled"),
      e && (this.submitButtonText.textContent = e);

    else {
      this.submitButton.removeAttribute("disabled"),
        "true" !== this.submitButton.dataset.textOverride
        && (!this.persistentTextActive
          ? this.originalButtonText
            ? this.submitButtonText.textContent = this.originalButtonText
            : this.submitButton.dataset.originalText
              ? this.submitButtonText.textContent = this.submitButton.dataset.originalText
              : this.submitButtonText.textContent = window.variantStrings.addToCart
          : (() => {
            const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
            t && (this.submitButtonText.textContent = t)
          })()
        )
    }
  }

  disconnectedCallback() {
    this.buttonTextObserver && this.buttonTextObserver.disconnect(),
      document.removeEventListener("variant:change", this.handleVariantChange)
  }

  get variantIdInput() {
    return this.form.querySelector("[name=id]")
  }
});
